'use strict';

import $ from 'jquery';
import utilities from '../../js/utilities';
import FormView from '../Form/FormView';

export class FooterContactTabPanelView {
  constructor($panel) {
    this.$panel = $panel;
    this.initialize();
  }

  initialize() {
    var $form = this.$panel.find('form');

    if ($form.length) {
      // Create form views
      this.formView = new FormView({ el: $form });

      // When form is submitted
      this.formView.$el.on('submit', this.onSubmit.bind(this));
    }
  }

  onSubmit() {
    // When the form is valid
    if (!this.formView.validator.numberOfInvalids()) {

      // Create a promise object to start an ajax call
      var promise = $.ajax(this.formView.$el.attr('action'), {
        dataType: 'json',
        method: 'post',
        handleErrorLocally: true,
        data: utilities.addCustIpToDataObject({})
      });

      // Process response with callbacks
      promise.done(this.onSubmitSuccess.bind(this));
      promise.fail(this.onSubmitFailed.bind(this));

    }

    return false;
  }

  onSubmitSuccess() {
    // When the form is successfully submitted, display message
    this.$panel.addClass('is-successfully-submitted');
  }

  onSubmitFailed(res) {
    // When the form has errors display messages
    if (res.responseJSON && res.responseJSON.errors) {
      var errors = res.responseJSON.errors;
      for (var i = 0; i < errors.length; i++) {
        var error = errors[i];
        this.$panel.find('#' + error.id).addClass('is-invalid');
      }
    }
  }
}




// WEBPACK FOOTER //
// ./assets/components/Footer/FooterContactTabPanelView.js